import React from "react";
import { FormattedNumber } from "react-intl";
import PropTypes from "prop-types";

import { CURRENCY } from "../../../constants";

const SrCurrency = (props) => <FormattedNumber {...props} />;

SrCurrency.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.string,
  currency: PropTypes.string,
};

SrCurrency.defaultProps = {
  value: undefined,
  style: "currency",
  currency: CURRENCY.MXN,
};

export default SrCurrency;
